import { defineMessages } from "locales/defineMessages";

// Shared components (sidebar, form fields, bulk bar), notification screens
// and service fallbacks.
export default defineMessages({
  vi: {
    "sidebar.defaultUserName": "Người dùng",
    "sidebar.expand": "Mở rộng thanh bên",
    "sidebar.collapse": "Thu gọn thanh bên",
    "sidebar.logoAlt": "Logo OmniSport",
    "sidebar.avatarAlt": "Ảnh đại diện",
    "sidebar.trialExpiredShort": "Đã hết hạn dùng thử",
    "sidebar.trialDaysLeft": "Dùng thử: còn {days} ngày",
    "sidebar.trialExpiredTitle": "Hết hạn dùng thử",
    "sidebar.trialExpiringTitle": "Dùng thử sắp hết hạn",
    "sidebar.trialExpiredBody":
      "Tài khoản dùng thử của trung tâm {center} đã hết hạn. Vui lòng liên hệ quản trị viên hệ thống để gia hạn sử dụng.",
    "sidebar.trialExpiringBody":
      "Tài khoản dùng thử của trung tâm {center} sẽ hết hạn sau {duration}. Vui lòng liên hệ quản trị viên hệ thống để gia hạn sử dụng.",
    "sidebar.trialDays": "{days} ngày",
    "sidebar.gotIt": "Đã hiểu",

    "relativeTime.justNow": "Vừa xong",
    "relativeTime.minutesAgo": "{count} phút trước",
    "relativeTime.hoursAgo": "{count} giờ trước",
    "relativeTime.daysAgo": "{count} ngày trước",

    "notifications.type.SESSION_REMINDER": "Nhắc nhở buổi học",
    "notifications.type.SESSION_CANCELLED": "Hủy buổi học",
    "notifications.type.SESSION_UPDATED": "Cập nhật buổi học",
    "notifications.type.SESSION_REPORT_SUBMITTED": "Báo cáo mới",
    "notifications.type.SESSION_REPORT_UPDATED": "Báo cáo cập nhật",
    "notifications.type.STAFF_CHECKED_IN": "Chấm công vào",
    "notifications.type.STAFF_CHECKED_OUT": "Chấm công ra",
    "notifications.type.LEAVE_REQUESTED": "Đơn xin nghỉ",
    "notifications.type.LEAVE_APPROVED": "Đơn xin nghỉ được duyệt",
    "notifications.type.LEAVE_REJECTED": "Đơn xin nghỉ bị từ chối",
    "notifications.type.GENERAL": "Chung",
    "notifications.filterNewReports": "Báo cáo mới",
    "notifications.filterUpdatedReports": "Báo cáo cập nhật",
    "notifications.pageDescription":
      "Theo dõi thay đổi quan trọng của buổi học, báo cáo và nhắc nhở theo cùng một hệ màu trạng thái.",
    "notifications.emptyDescription":
      "Khi có nhắc nhở buổi học, thay đổi lịch hoặc báo cáo mới, chúng sẽ xuất hiện tại đây.",
    "notifications.roleFilter.ALL": "Tất cả",
    "notifications.roleFilter.ALL_STAFF": "Nhân viên",
    "notifications.selectedCount": "({count} đã chọn)",
    "notifications.scheduleLabel": "Hẹn giờ gửi",
    "notifications.optional": "(tùy chọn)",
    "notifications.scheduledAt": "Hẹn lúc {time}",
    "notifications.scheduleSendAt": "Hẹn gửi lúc {time} {date}",
    "notifications.scheduledSuccess": "Đã hẹn gửi thông báo đến {count} người",

    "notifySession.sendTo": "Gửi đến",
    "notifySession.staffOption": "Nhân viên (Quản lý lớp, HLV)",
    "notifySession.scheduleSend": "Hẹn gửi",
    "notifySession.sentSuccess": "Đã gửi thông báo đến {count} học viên",

    "dateTimeInput.placeholder": "Chọn ngày giờ",
    "dateTimeInput.pickDateFirst": "Chọn ngày trước",
    "dateTimeInput.thenPickTime": "Chọn giờ sau",
    "dateTimeInput.hourOption": "{hour} giờ",
    "dateTimeInput.minuteOption": "{minute} phút",
    "dateTimeInput.outOfRange": "Thời gian đã chọn nằm ngoài phạm vi cho phép.",
    "dateTimeInput.apply": "Áp dụng",

    "bulkSelect.selectedCount": "Đã chọn {count} mục",
    "bulkSelect.clear": "Bỏ chọn",
    "bulkSelect.deleteSelected": "Xóa đã chọn",

    "leaveRequests.timeOnDate": "{time} ngày {day}",

    "teaching.actionSuccess": "Thao tác thành công",
    "teaching.defaultClassTitle": "Lớp học",
    "teaching.defaultCenterName": "Trung tâm",
  },
  en: {
    "sidebar.defaultUserName": "User",
    "sidebar.expand": "Expand sidebar",
    "sidebar.collapse": "Collapse sidebar",
    "sidebar.logoAlt": "OmniSport logo",
    "sidebar.avatarAlt": "Avatar",
    "sidebar.trialExpiredShort": "Trial expired",
    "sidebar.trialDaysLeft": "Trial: {days} days left",
    "sidebar.trialExpiredTitle": "Trial expired",
    "sidebar.trialExpiringTitle": "Trial ending soon",
    "sidebar.trialExpiredBody":
      "The trial account for {center} has expired. Please contact your system admin to extend it.",
    "sidebar.trialExpiringBody":
      "The trial account for {center} expires in {duration}. Please contact your system admin to extend it.",
    "sidebar.trialDays": "{days} days",
    "sidebar.gotIt": "Got it",

    "relativeTime.justNow": "Just now",
    "relativeTime.minutesAgo": "{count}m ago",
    "relativeTime.hoursAgo": "{count}h ago",
    "relativeTime.daysAgo": "{count}d ago",

    "notifications.type.SESSION_REMINDER": "Session reminder",
    "notifications.type.SESSION_CANCELLED": "Session cancelled",
    "notifications.type.SESSION_UPDATED": "Session updated",
    "notifications.type.SESSION_REPORT_SUBMITTED": "New report",
    "notifications.type.SESSION_REPORT_UPDATED": "Report updated",
    "notifications.type.STAFF_CHECKED_IN": "Staff checked in",
    "notifications.type.STAFF_CHECKED_OUT": "Staff checked out",
    "notifications.type.LEAVE_REQUESTED": "Leave request",
    "notifications.type.LEAVE_APPROVED": "Leave request approved",
    "notifications.type.LEAVE_REJECTED": "Leave request rejected",
    "notifications.type.GENERAL": "General",
    "notifications.filterNewReports": "New reports",
    "notifications.filterUpdatedReports": "Updated reports",
    "notifications.pageDescription":
      "Track important changes to sessions, reports and reminders, color-coded by status.",
    "notifications.emptyDescription":
      "Session reminders, schedule changes and new reports will appear here.",
    "notifications.roleFilter.ALL": "All",
    "notifications.roleFilter.ALL_STAFF": "Staff",
    "notifications.selectedCount": "({count} selected)",
    "notifications.scheduleLabel": "Schedule send",
    "notifications.optional": "(optional)",
    "notifications.scheduledAt": "Scheduled for {time}",
    "notifications.scheduleSendAt": "Schedule for {time} {date}",
    "notifications.scheduledSuccess":
      "Notification scheduled for {count} people",

    "notifySession.sendTo": "Send to",
    "notifySession.staffOption": "Staff (class managers, trainers)",
    "notifySession.scheduleSend": "Schedule",
    "notifySession.sentSuccess": "Notification sent to {count} students",

    "dateTimeInput.placeholder": "Select date and time",
    "dateTimeInput.pickDateFirst": "Pick a date first",
    "dateTimeInput.thenPickTime": "Then pick a time",
    "dateTimeInput.hourOption": "{hour} h",
    "dateTimeInput.minuteOption": "{minute} min",
    "dateTimeInput.outOfRange":
      "The selected time is outside the allowed range.",
    "dateTimeInput.apply": "Apply",

    "bulkSelect.selectedCount": "{count} selected",
    "bulkSelect.clear": "Clear selection",
    "bulkSelect.deleteSelected": "Delete selected",

    "leaveRequests.timeOnDate": "{time} on {day}",

    "teaching.actionSuccess": "Action completed successfully",
    "teaching.defaultClassTitle": "Class",
    "teaching.defaultCenterName": "Center",
  },
});
